module.exports = __webpack_public_path__ + "static/media/Starmie_gaussian2.35068e0b.png";